module.exports = __webpack_public_path__ + "static/media/codeTurtleRace.4be6e410.gif";